import { render } from "./ExitGamePopUp.vue?vue&type=template&id=14cddf10&scoped=true"
import script from "./ExitGamePopUp.vue?vue&type=script&lang=js"
export * from "./ExitGamePopUp.vue?vue&type=script&lang=js"

import "./ExitGamePopUp.vue?vue&type=style&index=0&id=14cddf10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14cddf10"]])

export default __exports__